import { Pipe, PipeTransform } from '@angular/core';
import { StripeSubscriptionStatus } from '@workspace/data-types';
import { CoreNiceLabelUtils } from '../core-nice-label.utils';

@Pipe({
  name: 'subscriptionStatusDisplay',
})
export class SubscriptionStatusDisplayPipe implements PipeTransform {
  transform(value: StripeSubscriptionStatus | string): string {
    return subscriptionStatusDisplayTransform(value);
  }
}

export function subscriptionStatusDisplayTransform(value: StripeSubscriptionStatus | string) {
  return CoreNiceLabelUtils.subscriptionStatus(value);
}
